import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import * as XLSX from 'xlsx'
import {
  TextField,
  Box,
  Button,
  Grid,
  InputAdornment,
  Typography,
  CircularProgress,
  MenuItem,
  Popover,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "components/structure/Layout";
import SurveyTableSubGrower from "./SurveyTableSubGrower";
import { SnackbarContext } from "context/snackBarContext";
import CustomPagination from "../Import/Common/CustomPagination";
import CommonService from "services/CommonService";
import HierarchyDropdown from "../ManageUnannouncedVisitor/HierarchyDropdown";
import SurveyManagementSubGrowerService from "services/SurveyManagementSubGrowerService";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import ReopenModal from "./ReopenModal";
import ApproveModal from "./ApproveModal";
import ViewSurveySubGrower from "./ViewSurveySubGrower";
import SignaturePageSubGrower from "./SignaturePageSubGrower";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import DuplicateModal from "./DuplicateModal";
import Service from "../../../services/ManageUnannouncedVisitorService";
import { equalsIgnoreCase, hasSelectedOption } from "utils/utils";

dayjs.extend(utc);
let setStaticSelectedCountryCode = [];

const SurveyReopenSubGrower = () => {
  const [loading, setLoading] = useState(false);
  const [surveyData, setSurveyData] = useState([]);
  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);
  const [cropYears, setCropYears] = useState([]);
  const [selectedCropYear, setSelectedCropYear] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [hierarchyData, setHierarchyData] = useState([]);
  const [selectedHierarchy, setSelectedHierarchy] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const user = JSON.parse(sessionStorage.getItem("BAT_USER"));
  const [countries, setCountries] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [statusPickList, setStatusPickList] = useState([]);
  const [selectedStatusPickList, setSelectedStatusPickList] = useState([]);
  const [cropStages, setCropStages] = useState([]);
  const [selectedCropStage, setSelectedCropStage] = useState("");
  const [surveyStartDate, setSurveyStartDate] = useState(null);
  const [surveyEndDate, setSurveyEndDate] = useState(null);
  const [selectedForReopen, setSelectedForReopen] = useState(new Set());
  const [selectedForApprove, setSelectedForApprove] = useState(new Set());
  const [isApprover, setIsApprover] = useState(false);
  const [isGlobalProfile, setIsGlobalProfile] = useState(
    user?.userAttribute == "Global" ? true : false
  );
  const [reopenModalOpen, setReopenModalOpen] = useState(false);
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [isVisitCompliance, setIsVisitCompliance] = useState(false);
  const [currentView, setCurrentView] = useState("main"); // 'main', 'view', 'signature'
  const [selectedSurveyData, setSelectedSurveyData] = useState(null);
  const [bulkActions, setBulkActions] = useState({
    bulkReopen: false,
    bulkApprove: false,
  });
  const isStatusUserChangeRef = useRef(false);
  const operationalLevelRef = useRef(null);
  const [popoverWidth, setPopoverWidth] = useState(0);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  // Active when the Sub Grower's isSGActive is true, Inactive when false.
  // Computed client-side from already-fetched rows; not sent to the API.
  const [selectedSubGrowerStatus, setSelectedSubGrowerStatus] = useState("all");
  const [duplicateMessage, setDuplicateMessage] = useState("");
  const [duplicateModal, setDuplicateModal] = useState(false);

  const [cropSeasons, setCropSeasons] = useState([]);
  const [selectedCropSeason, setSelectedCropSeason] = useState("");
  const cropSeasonRef = useRef(null);
  const [cropSeasonDropdownWidth, setCropSeasonDropdownWidth] = useState(null);

  const moduleName = "Survey Reopen/Approve";
  const functionalityName = "Survey Reopen/Approve - Sub Grower";

  const read_only_user = user?.accessibleModules
    ?.find(module => module.module_name === moduleName)
    ?.accessible_functionalities
    ?.find(func => func.functionality_name === functionalityName)
    ?.read_only;

  useEffect(() => {
    if (cropSeasonRef.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          setCropSeasonDropdownWidth(entry.target.offsetWidth);
        }
      });
      resizeObserver.observe(cropSeasonRef.current);
      return () => resizeObserver.disconnect();
    }
  }, []);

  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    if (!selectedCountries?.countryCode) return;
    setTimeout(() => {
      getCropYear();
      getStatusPickList();
    }, 1000);
  }, [selectedCountries]);

  const fetchIsApprover = async (cropYear) => {
    if (!cropYear) return;
    try {
      const headers = getXTenantIDHeader();
      if (headers?.apiCountryCode === "") return;
      const response = await SurveyManagementSubGrowerService.getIsApprover(cropYear, { headers });
      if (response?.data?.response) {
        setIsApprover(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching isApprover data:", error);
    }
  };
  const fetchCountries = () => {
    CommonService?.fetchCountries()
      .then((res) => {
        let countries = res?.data?.response;
        setCountries(countries);
        const kenCountry = countries.find(
          (country) => country.countryCode === "HRV"
        );
        if (kenCountry) {
          setStaticSelectedCountryCode = kenCountry;
          setSelectedCountries(kenCountry);
        } else {
          setSelectedCountries(countries[0]);
        }
      })
      .catch((ex) => {
        setCountries([]);
        console.log("error", ex);
      });
  };
  const fetchHierarchyData = async (cropYear) => {
    if (!cropYear) return;
    try {
      let headers = getXTenantIDHeader();
      if (headers?.apiCountryCode == "") return;
      const response = await SurveyManagementSubGrowerService.getHierarchyDropdown(
        { isMuv: true, cropYear },
        { headers }
      );
      if (response?.data?.response) {
        const hierarchyData = response.data.response;
        setHierarchyData(hierarchyData);
        const { allIds, allLocations } = getAllNodesData(hierarchyData);
        setSelectedHierarchy(allIds);
        setSelectedLocations(allLocations);
      }
    } catch (error) {
      setSelectedHierarchy([]);
      setSelectedLocations([]);
      setHierarchyData([]);
      console.error("Error fetching hierarchy data:", error);
    }
  };
  const getCropYear = () => {
    let headers = getXTenantIDHeader();
    if (headers?.apiCountryCode === "") return;

    SurveyManagementSubGrowerService?.getCropYear({ headers })
      .then((res) => {
        const cropYearData = res?.data?.response || [];
        setCropYears(cropYearData);

        const currentCropYear = cropYearData.find(
          (year) => year.isCurrentCropYear === true
        );
        if (currentCropYear) {
          setSelectedCropYear(currentCropYear.cropYear);
        }
      })
      .catch((error) => {
        setCropYears([]);
        console.error("Error fetching crop years:", error);
      });
  };

  useEffect(() => {
    if (selectedCropYear) {
      fetchCropSeasonsAndStages(selectedCropYear);
      fetchHierarchyData(selectedCropYear);
      fetchIsApprover(selectedCropYear);
    }
  }, [selectedCropYear]);

  const handleCropYearChange = (e) => {
    setSelectedCropYear(e.target.value);
    setSelectedCropSeason("");
    setSelectedCropStage("");
    setCropStages([]);
    setSelectedLocations([]);
    setSelectedHierarchy([]);
    clearSelections();
    setCurrentPage(0);
  };

  const getStatusPickList = () => {
    let headers = getXTenantIDHeader();

    SurveyManagementSubGrowerService.fetchPickListSurvey(
      { pickListCodes: ["CSSSTAT"] },
      { headers: headers }
    )
      .then((res) => {
        let data = res?.data?.response?.CSSSTAT;
        const validData = Array.isArray(data) && data.length > 0 ? data : [];
        setStatusPickList(validData);
        setSelectedStatusPickList(validData);
      })
      .catch((ex) => {
        setStatusPickList([]);
        setSelectedStatusPickList([]);
        console.log("error", ex);
      });
  };
  const getXTenantIDHeader = () => {
    const headers = {};
    let selectedCountryCode = "";
    if (user?.userAttribute == "Global") {
      selectedCountryCode = setStaticSelectedCountryCode?.countryCode;
    }
    if (user?.userAttribute == "Local") {
      selectedCountryCode = user?.countryCode;
    }
    headers["apiCountryCode"] = selectedCountryCode;
    return headers;
  };

  const handleStartDateChange = (newValue) => {
    if (surveyEndDate && newValue > surveyEndDate) {
      setSeverity("error");
      setMessage("Survey start date cannot be after the survey end date");
      setOpenAlert(true);
      return;
    }
    setSurveyStartDate(newValue);
    clearSelections();
    setCurrentPage(0);
  };
  useEffect(() => {
    fetchSurveyData(currentPage, itemsPerPage);
  }, [surveyStartDate]);

  const handleEndDateChange = (newValue) => {
    if (surveyStartDate && newValue < surveyStartDate) {
      setSeverity("error");
      setMessage("Survey end date cannot be before the survey start date");
      setOpenAlert(true);
      return;
    }
    setSurveyEndDate(newValue);
    clearSelections();
    setCurrentPage(0);
  };
  useEffect(() => {
    fetchSurveyData(currentPage, itemsPerPage);
  }, [surveyEndDate]);

  const fetchCropSeasonsAndStages = async (cropYear) => {
    try {
      const headers = getXTenantIDHeader();
      if (!headers?.apiCountryCode) return;

      const response = await Service.getCropStageSurveyReopen(
        { cropYear, isSubGrowerMonitoring: true },
        { headers }
      );

      const seasons = response?.data?.response || [];
      setCropSeasons(seasons);

      if (seasons.length > 0) {
        const firstSeason = seasons[0];
        setSelectedCropSeason(firstSeason.cropSeasonId);

        const activeStages =
          firstSeason.cropStages
            ?.filter((s) => s.isActive)
            ?.map((s) => ({
              value: s.cropStageId,
              label: s.cropStageName,
              isVisitCompliance: s.isVisitCompliance,
              cropStageCalendarId: s.cropStageCalendarId,
            })) || [];

        setCropStages(activeStages);

        if (activeStages.length > 0) {
          setSelectedCropStage(activeStages[0].value);
          setIsVisitCompliance(activeStages[0].isVisitCompliance || false);
        } else {
          setSelectedCropStage("");
          setIsVisitCompliance(false);
        }
      } else {
        setSelectedCropSeason("");
        setCropStages([]);
        setSelectedCropStage("");
        setIsVisitCompliance(false);
      }
    } catch (error) {
      console.error("Error fetching crop seasons/stages:", error);
      setCropSeasons([]);
      setSelectedCropSeason("");
      setCropStages([]);
      setSelectedCropStage("");
      setIsVisitCompliance(false);
      setSurveyData([])
    }
  };

  const handleCropSeasonChange = (e) => {
    const seasonId = e.target.value;
    setSelectedCropSeason(seasonId);

    const selectedSeasonData = cropSeasons.find(
      (season) => season.cropSeasonId === seasonId
    );

    const activeCropStages =
      selectedSeasonData?.cropStages
        ?.filter((stage) => stage.isActive)
        .map((stage) => ({
          value: stage.cropStageId,
          label: stage.cropStageName,
          isVisitCompliance: stage.isVisitCompliance,
          cropStageCalendarId: stage.cropStageCalendarId,
        })) || [];

    setCropStages(activeCropStages);

    if (activeCropStages.length > 0) {
      const firstStage = activeCropStages[0];
      setSelectedCropStage(firstStage.value);
      setIsVisitCompliance(firstStage.isVisitCompliance || false);
      setSelectedCropSeason(seasonId);
    } else {
      setSelectedCropStage("");
      setIsVisitCompliance(false);
    }

    clearSelections();
    setCurrentPage(0);
  };

  useEffect(() => {
    if (selectedCropStage && selectedLocations.length > 0) {
      fetchSurveyData(currentPage, itemsPerPage);
    }
  }, [selectedCropStage, selectedCropSeason, selectedLocations]);

  const selectedCropStageCalendarId = cropStages.find(
    (stage) => stage.value === selectedCropStage
  )?.cropStageCalendarId;

  // Sent to the backend so the filter is applied in the query (keeps pagination correct).
  // Omitted for "all" so both Active and Inactive sub growers are returned.
  const subGrowerStatusParam =
    selectedSubGrowerStatus === "all"
      ? {}
      : { isSGActive: selectedSubGrowerStatus === "Active" };

  useEffect(() => {
    if (selectedCropStage && selectedLocations.length > 0) {
      clearSelections();
      setCurrentPage(0);
      fetchSurveyData(0, itemsPerPage);
    }
  }, [selectedSubGrowerStatus]);

  const fetchSurveyData = async (pageNumber, pageSize) => {
    if (selectedCropStage == "") return;
    if (selectedLocations.length === 0) return;

    const params = {
      pageNumber: pageNumber,
      size: pageSize,
      locationCodes: [...selectedLocations],
      // Backend field is misspelled "Calender" (not "Calendar") - must match exactly.
      cropStageCalenderId: selectedCropStageCalendarId,
      cropSeasonId: selectedCropSeason,
      status: (selectedStatusPickList || []).map((status) => status.pickListItemCode),
      ...subGrowerStatusParam,
      ...(surveyStartDate && { fromDate: surveyStartDate.format("YYYY-MM-DD") }),
      ...(surveyEndDate && { toDate: surveyEndDate.format("YYYY-MM-DD") }),
      ...(debouncedSearchTerm && { keyword: debouncedSearchTerm }),
    };

    let headers = getXTenantIDHeader();
    if (headers?.apiCountryCode == "") return;

    try {
      setLoading(true);
      const response = await SurveyManagementSubGrowerService?.getSurveyApproverData(
        params,
        { headers }
      );
      setLoading(false);

      // The Sub Grower survey list is expected one row per Sub Grower (not
      // merged per property, unlike the Farmer survey list).
      const apiSurveyData = response?.data?.response?.surveyData || [];
      const newSurveyData = apiSurveyData.map(
        (item) => ({
          ...item,
          isReopen: selectedForReopen.has(item.headerId),
          isApproved: selectedForApprove.has(item.headerId),
        })
      );
      setSurveyData(newSurveyData);
      setTotalItems(response?.data?.response?.totalItems || newSurveyData.length);
      setCurrentPage(pageNumber);
    } catch (error) {
      setLoading(false);
      setSurveyData([]);
      setTotalItems(0);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
    }
  };

  const getAllNodesData = (data) => {
    const allIds = [];
    const allLocations = new Set();

    const traverse = (items) => {
      items.forEach((item) => {
        allIds.push(item.ihId);
        allLocations.add(item.ihLocationCode);

        if (item.childHierarchy) {
          traverse(item.childHierarchy);
        }
      });
    };

    traverse(data);
    return {
      allIds,
      allLocations: Array.from(allLocations),
    };
  };
  const handleStatusChange = (event) => {
    const selectedValue = event.target.value;
    isStatusUserChangeRef.current = true;
    if (hasSelectedOption(selectedValue, "all")) {
      setSelectedStatusPickList(
        selectedStatusPickList.length === statusPickList.length
          ? []
          : [...statusPickList]
      );
    } else {
      setSelectedStatusPickList(selectedValue);
    }
    clearSelections();
    setCurrentPage(0);
  };
  useEffect(() => {
    if (isStatusUserChangeRef.current) {
      isStatusUserChangeRef.current = false;
      fetchSurveyData(currentPage, itemsPerPage);
    }
  }, [selectedStatusPickList]);

  const handleAssignmentUpdate = (updatedItem, type) => {
    const isCurrentlyReopen = Boolean(
      surveyData.find(
        (item) => item.headerId === updatedItem.headerId && item.isReopen
      )
    );
    const isCurrentlyApprove = Boolean(
      surveyData.find(
        (item) => item.headerId === updatedItem.headerId && item.isApproved
      )
    );

    const newItem = {
      ...updatedItem,
      isReopen: updatedItem.isReopen
        ? type == "bulk"
          ? updatedItem?.isReopen
          : !isCurrentlyReopen
        : false,
      isApproved: updatedItem.isApproved
        ? type == "bulk"
          ? updatedItem.isApproved
          : !isCurrentlyApprove
        : false,
    };

    setSurveyData((prevData) =>
      prevData.map((item) =>
        item.headerId === newItem.headerId ? newItem : item
      )
    );

    if (newItem.isReopen) {
      setSelectedForReopen((prev) => {
        const newSet = new Set(prev);
        newSet.add(newItem.headerId);
        return newSet;
      });
      setSelectedForApprove((prev) => {
        const newSet = new Set(prev);
        newSet.delete(newItem.headerId);
        return newSet;
      });
    } else if (newItem.isApproved) {
      setSelectedForApprove((prev) => {
        const newSet = new Set(prev);
        newSet.add(newItem.headerId);
        return newSet;
      });
      setSelectedForReopen((prev) => {
        const newSet = new Set(prev);
        newSet.delete(newItem.headerId);
        return newSet;
      });
    } else {
      setSelectedForReopen((prev) => {
        const newSet = new Set(prev);
        newSet.delete(newItem.headerId);
        return newSet;
      });
      setSelectedForApprove((prev) => {
        const newSet = new Set(prev);
        newSet.delete(newItem.headerId);
        return newSet;
      });
    }
  };

  const handleReopenSubmit = () => {
    if (selectedForReopen.size === 0) return;
    setReopenModalOpen(true);
  };

  const handleReopenConfirm = async (comment) => {
    try {
      setLoading(true);
      const selectedIds = Array.from(selectedForReopen);
      const today = dayjs().format("YYYY-MM-DDTHH:mm:ss");
      const selectedHeaderIds = selectedIds

      const completedSurveyIds = surveyData
        .filter((item) => item?.status?.toLowerCase() === "completed")
        .map((item) => item.headerId);

      const notSelectedIds = completedSurveyIds.filter(
        (id) => !selectedIds.includes(id)
      );

      const params = {
        locationCodes: [...selectedLocations],
        statusToUpdate: "Re-Opened",
        notInHeaderIds: bulkActions.bulkReopen ? notSelectedIds : [],
        reopenComment: comment,
        actionDate: today,
        // Backend field is misspelled "Calender" (not "Calendar") - must match exactly.
        cropStageCalenderId: selectedCropStageCalendarId,
        cropSeasonId: selectedCropSeason,
        status: (selectedStatusPickList || []).map((status) => status.pickListItemCode),
        ...subGrowerStatusParam,
        ...(surveyStartDate && {
          fromDate: surveyStartDate.format("YYYY-MM-DD"),
        }),
        ...(surveyEndDate && { toDate: surveyEndDate.format("YYYY-MM-DD") }),
      };
      if (debouncedSearchTerm !== "") {
        params.keyword = debouncedSearchTerm;
      }
      if (!bulkActions.bulkReopen) {
        params.headerIds = selectedHeaderIds;
      }
      let resp = await SurveyManagementSubGrowerService.reopenSurveys(params, {
        headers: getXTenantIDHeader(),
      });

      if (resp?.data?.response?.statusCode == 207) {
        setDuplicateMessage(resp?.data?.response?.message)
        setDuplicateModal(true)
        return
      }
      setSelectedForReopen(new Set());
      await fetchSurveyData(currentPage, itemsPerPage);

      setSeverity("success");
      setMessage("Surveys reopened successfully");
      setOpenAlert(true);
    } catch (error) {
      setSeverity("error");
      setMessage(error?.response?.data?.message || "Failed to reopen surveys");
      setOpenAlert(true);
    } finally {
      setLoading(false);
      setReopenModalOpen(false);
    }
  };

  const handleApproveSubmit = () => {
    if (selectedForApprove.size === 0) return;
    setApproveModalOpen(true);
  };

  const handleApproveConfirm = async (comment) => {
    try {
      setLoading(true);
      const selectedIds = Array.from(selectedForApprove);
      const today = dayjs().format("YYYY-MM-DDTHH:mm:ss");

      const selectedHeaderIds = selectedIds
      const completedSurveyIds = surveyData
        .filter((item) => item?.status?.toLowerCase() === "completed")
        .map((item) => item.headerId);

      const notSelectedIds = completedSurveyIds.filter(
        (id) => !selectedIds.includes(id)
      );

      const params = {
        locationCodes: [...selectedLocations],
        statusToUpdate: "Approved",
        notInHeaderIds: bulkActions.bulkApprove ? notSelectedIds : [],
        actionDate: today,
        approverName: user?.userName,
        // Backend field is misspelled "Calender" (not "Calendar") - must match exactly.
        cropStageCalenderId: selectedCropStageCalendarId,
        cropSeasonId: selectedCropSeason,
        status: (selectedStatusPickList || []).map((status) => status.pickListItemCode),
        ...subGrowerStatusParam,
        ...(surveyStartDate && {
          fromDate: surveyStartDate.format("YYYY-MM-DD"),
        }),
        ...(surveyEndDate && { toDate: surveyEndDate.format("YYYY-MM-DD") }),
      };
      if (debouncedSearchTerm !== "") {
        params.keyword = debouncedSearchTerm;
      }
      if (!bulkActions.bulkApprove) {
        params.headerIds = selectedHeaderIds;
      }
      await SurveyManagementSubGrowerService.reopenSurveys(params, {
        headers: getXTenantIDHeader(),
      });

      setSelectedForApprove(new Set());
      await fetchSurveyData(currentPage, itemsPerPage);

      setSeverity("success");
      setMessage("Surveys approved successfully");
      setOpenAlert(true);
    } catch (error) {
      setSeverity("error");
      setMessage(error?.response?.data?.message || "Failed to approve surveys");
      setOpenAlert(true);
    } finally {
      setLoading(false);
      setApproveModalOpen(false);
    }
  };

  const paginate = (pageNumber, pageSize) => {
    setSelectedForReopen(new Set([]));
    setSelectedForApprove(new Set([]));
    fetchSurveyData(pageNumber - 1, pageSize);
  };
  const handleOperationalLevelClick = (event) => {
    if (operationalLevelRef.current) {
      const width = operationalLevelRef.current.offsetWidth;
      setPopoverWidth(width);
    }
    setAnchorEl(event.currentTarget);
  };
  useEffect(() => {
    if (operationalLevelRef.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          setPopoverWidth(entry.target.offsetWidth);
        }
      });

      resizeObserver.observe(operationalLevelRef.current);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, []);

  const handleOperationalLevelClose = () => {
    setAnchorEl(null);
  };
  const handleHierarchySelect = (selectionData) => {
    const { selectedIds } = selectionData;
    setSelectedHierarchy(selectedIds);
    clearSelections();
    setCurrentPage(0);

    const filteredLocations = getFilteredLocationCodes(
      hierarchyData,
      selectedIds
    );
    setSelectedLocations(filteredLocations);
  };
  const getFilteredLocationCodes = (data, selectedIds) => {
    const locationCodes = new Set();

    const traverse = (items) => {
      items.forEach((item) => {
        if (selectedIds.includes(item.ihId)) {
          locationCodes.add(item.ihLocationCode);
        }

        if (item.childHierarchy) {
          traverse(item.childHierarchy);
        }
      });
    };

    traverse(data);
    return Array.from(locationCodes);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchKeyword);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [searchKeyword]);
  useEffect(() => {
    if (selectedCropYear) {
      setCurrentPage(0);
      fetchSurveyData(0, itemsPerPage);
    }
  }, [debouncedSearchTerm]);
  const clearSelections = () => {
    setSelectedForReopen(new Set());
    setSelectedForApprove(new Set());
  };

  const handleCountryChange = (e) => {
    const code = countries.find(
      (country) => country.countryCode === e.target.value
    );
    setStaticSelectedCountryCode = code;
    setSelectedCountries(code);
    setSelectedCropYear("");
    setSelectedCropSeason("");
    setSelectedCropStage("");
    setCropStages([]);
    setSelectedLocations([]);
    setSelectedHierarchy([]);
    clearSelections();
  };

  const handleViewSurvey = (surveyData) => {
    setSelectedSurveyData(surveyData);
    setCurrentView("view");
  };

  const handleShowSignature = () => {
    setCurrentView("signature");
  };

  const handleBack = () => {
    setCurrentView("main");
    setSelectedSurveyData(null);
  };

  const handleBulkActionChange = ({ bulkReopen, bulkApprove }) => {
    setBulkActions({ bulkReopen, bulkApprove });
  };
  const handleExportExcel = async () => {
    if (selectedCropStage === "") return;
    if (!selectedCropSeason) return;
    const params = {
      pageNumber: 0,
      size: 100000,
      locationCodes: [...selectedLocations],
      // Backend field is misspelled "Calender" (not "Calendar") - must match exactly.
      cropStageCalenderId: selectedCropStageCalendarId,
      cropSeasonId: selectedCropSeason,
      status: (selectedStatusPickList || []).map((status) => status.pickListItemCode),
      ...subGrowerStatusParam,
      ...(surveyStartDate && { fromDate: surveyStartDate.format("YYYY-MM-DD") }),
      ...(surveyEndDate && { toDate: surveyEndDate.format("YYYY-MM-DD") }),
      ...(searchKeyword && { keyword: searchKeyword }),
    };

    const headers = getXTenantIDHeader();
    if (headers?.apiCountryCode === "") return;

    try {
      setLoading(true);
      const response = await SurveyManagementSubGrowerService.getSurveyApproverData(
        params,
        { headers }
      );
      setLoading(false);

      const apiSurveyData = response?.data?.response?.surveyData || [];
      const surveyData = apiSurveyData;

      if (surveyData.length === 0) {
        setSeverity("info");
        setMessage("No data found to export.");
        setOpenAlert(true);
        return;
      }

      const exportData = surveyData.map((item) => {
        const growerNumbers = item?.allGrowerNos

        const cropStageName =
          cropStages.find((stage) => stage.value === selectedCropStage)?.label || "";

        const row = {
          "Crop Year": selectedCropYear,
          "Crop Stage": cropStageName,
          "Property No": item.propertyFarmNo,
          "Grower No": growerNumbers,
          "Sub Grower Code": item.permanentCode || item.temporaryCode,
        };

        if (!isGlobalProfile) {
          row["Farmer"] = item.allFarmerNames;
          row["Sub Grower Name"] = item.subGrowerName;
        }

        row["Survey Date"] = `\t${dayjs.utc(item?.surveyDate).format("DD/MM/YYYY")}`;
        row["Status"] = item.status;
        row["Approver Name"] = item.approverName || "";
        row["Approved Date"] = item.approvedDate ? `\t${dayjs.utc(item.approvedDate).format("DD/MM/YYYY")}` : "";

        return row;
      });

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Survey Reopen-Sub Grower');

      XLSX.writeFile(workbook, "Survey Reopen ⁄ Approve - Sub Grower.csv", { bookType: "csv" });
    } catch (error) {
      setLoading(false);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
    }
  };

  return (
    <Layout title="Survey Reopen / Approve - Sub Grower">
      {currentView === "main" && (
        <Box
          className="survey-container"
          sx={{ position: "relative", minHeight: "100vh" }}
        >
          <Typography
            sx={{
              color: "#102A62",
              fontFamily: "Montserrat",
              fontWeight: 600,
              fontSize: "20px",
              lineHeight: "30px",
              letterSpacing: 0,
              marginBottom: 2,
            }}
          >
            Survey Reopen / Approve - Sub Grower
          </Typography>

          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: "100%",
              marginTop: 1,
              marginLeft: 0.1,
              paddingTop: 3,
              paddingRight: 3,
              paddingBottom: 3,
              backgroundColor: "#EFEFEF",
            }}
          >
            {isGlobalProfile && (
              <Grid item xs={12} sm={1.7} sx={{ order: { xs: 1, sm: 1 } }}>
                <TextField
                  fullWidth
                  select
                  label="Country"
                  variant="outlined"
                  value={selectedCountries?.countryCode || ""}
                  onChange={handleCountryChange}
                  InputLabelProps={{
                    shrink: true,
                    sx: {
                      color: "#00000099",
                      fontFamily: "Montserrat",
                      fontWeight: 500,
                      fontSize: "18px",
                      lineHeight: "20px",
                      letterSpacing: "0%",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "46px",
                      borderRadius: "5px",
                      "& fieldset": {
                        borderColor: "#C4C4C4",
                        borderRadius: "5px",
                      },
                      "&:hover fieldset": {
                        borderColor: "#C4C4C4",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#C4C4C4",
                      },
                    },
                  }}
                >
                  {countries?.map((c) => (
                    <MenuItem key={c.countryName} value={c.countryCode}>
                      {c.countryName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            <Grid item xs={12} sm={3.4} sx={{ order: { xs: 4, sm: 4 } }}>
              <TextField
                ref={operationalLevelRef}
                fullWidth
                label="Operational Level"
                variant="outlined"
                onClick={handleOperationalLevelClick}
                value={`${selectedHierarchy.length} Selected`}
                InputProps={{
                  readOnly: true,
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: "#00000099",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                    cursor: "pointer",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "46px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    "& input": {
                      height: "46px",
                      padding: "0 14px",
                      boxSizing: "border-box",
                    },
                    "& fieldset": {
                      borderColor: "#C4C4C4",
                      borderRadius: "5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#C4C4C4",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C4C4C4",
                    },
                  },
                }}
              />
              <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleOperationalLevelClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                PaperProps={{
                  sx: {
                    height: "auto",
                    width: popoverWidth || "auto",
                    maxHeight: 273,
                    overflow: "auto",
                  },
                }}
              >
                <div
                  style={{
                    width: "100%",
                    maxHeight: 273,
                  }}
                >
                  <HierarchyDropdown
                    hierarchyData={hierarchyData}
                    selectedItems={selectedHierarchy}
                    onSelectionChange={handleHierarchySelect}
                  />
                </div>
              </Popover>
            </Grid>
            <Grid item xs={12} sm={1.7} sx={{ order: { xs: 2, sm: 2 } }}>
              <TextField
                fullWidth
                select
                label="Crop Year"
                variant="outlined"
                value={selectedCropYear || ""}
                onChange={handleCropYearChange}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: "#00000099",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "46px",
                    borderRadius: "5px",
                    "& fieldset": {
                      borderColor: "#C4C4C4",
                      borderRadius: "5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#C4C4C4",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C4C4C4",
                    },
                  },
                }}
              >
                {cropYears.map((yearData) => (
                  <MenuItem
                    key={yearData.cropYearUid}
                    value={yearData.cropYear}
                  >
                    {yearData.cropYearName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={1.7} sx={{ order: { xs: 3, sm: 3 } }}>
              <TextField
                ref={cropSeasonRef}
                fullWidth
                select
                label="Crop Season"
                variant="outlined"
                value={selectedCropSeason}
                onChange={handleCropSeasonChange}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: "#00000099",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                  },
                }}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        width: cropSeasonDropdownWidth || "auto",
                        maxHeight: 273,
                        "& .MuiMenuItem-root": {
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          minHeight: "unset",
                          padding: "6px 16px",
                        },
                      },
                    },
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "46px",
                    borderRadius: "5px",
                    "& fieldset": {
                      borderColor: "#C4C4C4",
                      borderRadius: "5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#C4C4C4",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C4C4C4",
                    },
                  },
                }}
              >
                {cropSeasons.map((season) => (
                  <MenuItem key={season.cropSeasonId} value={season.cropSeasonId}>
                    {season.cropSeasonName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={1.7} sx={{ order: { xs: 6, sm: 6 } }}>
              <TextField
                fullWidth
                select
                label="Survey Status"
                variant="outlined"
                value={selectedStatusPickList || []}
                onChange={handleStatusChange}
                SelectProps={{
                  multiple: true,
                  renderValue: (selected) =>
                    selected
                      .map((status) => status.pickListDescription)
                      .join(", "),
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 250,
                        overflowY: "auto",
                      },
                    },
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: "#00000099",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "46px",
                    borderRadius: "5px",
                    "& fieldset": {
                      borderColor: "#C4C4C4",
                      borderRadius: "5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#C4C4C4",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C4C4C4",
                    },
                  },
                }}
              >
                <MenuItem value="all">
                  <ListItemIcon>
                    <Checkbox
                      checked={
                        selectedStatusPickList?.length ===
                        statusPickList?.length
                      }
                      indeterminate={
                        selectedStatusPickList?.length > 0 &&
                        selectedStatusPickList?.length < statusPickList?.length
                      }
                      icon={<img src={CheckboxUntick} alt="Unchecked" />}
                      checkedIcon={<img src={CheckboxTick} alt="Checked" />}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Select All" />
                </MenuItem>
                {statusPickList?.map((data) => (
                  <MenuItem key={data?.pickListItemCode} value={data}>
                    <ListItemIcon>
                      <Checkbox
                        checked={selectedStatusPickList.some(
                          (item) =>
                            equalsIgnoreCase(item.pickListItemCode, data.pickListItemCode)
                        )}
                        icon={<img src={CheckboxUntick} alt="Unchecked" />}
                        checkedIcon={<img src={CheckboxTick} alt="Checked" />}
                      />
                    </ListItemIcon>
                    <ListItemText primary={data.pickListDescription} />
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={1.7} sx={{ order: { xs: 7, sm: 7 } }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Survey Start Date"
                  value={surveyStartDate}
                  onChange={handleStartDateChange}
                  maxDate={surveyEndDate}
                  format="DD-MM-YYYY"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      height: "46px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      "& input": {
                        cursor: "pointer",
                        pointerEvents: "none",
                      },
                      "& fieldset": {
                        borderColor: "#C4C4C4",
                        borderRadius: "5px",
                      },
                      "&:hover fieldset": {
                        borderColor: "#C4C4C4",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#C4C4C4",
                      },
                    },
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      onClick: (e) =>
                        e.currentTarget.querySelector("button").click(),
                      InputLabelProps: {
                        shrink: true,
                        sx: {
                          color: "#00000099",
                          fontFamily: "Montserrat",
                          fontWeight: 500,
                          fontSize: "18px",
                          lineHeight: "20px",
                          letterSpacing: "0%",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={1.7} sx={{ order: { xs: 8, sm: 8 } }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Survey End Date"
                  value={surveyEndDate}
                  onChange={handleEndDateChange}
                  minDate={surveyStartDate}
                  format="DD-MM-YYYY"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      height: "46px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      "& input": {
                        cursor: "pointer",
                        pointerEvents: "none",
                      },
                      "& fieldset": {
                        borderColor: "#C4C4C4",
                        borderRadius: "5px",
                      },
                      "&:hover fieldset": {
                        borderColor: "#C4C4C4",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#C4C4C4",
                      },
                    },
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      onClick: (e) =>
                        e.currentTarget.querySelector("button").click(),
                      InputLabelProps: {
                        shrink: true,
                        sx: {
                          color: "#00000099",
                          fontFamily: "Montserrat",
                          fontWeight: 500,
                          fontSize: "18px",
                          lineHeight: "20px",
                          letterSpacing: "0%",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            sx={{
              marginLeft: 0,
              paddingBottom: 2,
              paddingRight: 3,
              width: "100%",
              backgroundColor: "#EFEFEF",
            }}
          >
            <Grid item xs={12} sm={5.5}>
              <TextField
                fullWidth
                label="Search by Property No / Grower No / Sub Grower Code"
                variant="outlined"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#00000099" }} />
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: "#00000099",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "46px",
                    borderRadius: "5px",
                    "& input": {
                      height: "46px",
                      padding: "0 14px",
                      boxSizing: "border-box",
                    },
                    "& fieldset": {
                      borderColor: "#C4C4C4",
                      borderRadius: "5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#C4C4C4",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C4C4C4",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={1.75}>
              <TextField
                fullWidth
                select
                label="Status"
                variant="outlined"
                value={selectedSubGrowerStatus}
                onChange={(e) => setSelectedSubGrowerStatus(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: "#00000099",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "46px",
                    borderRadius: "5px",
                    "& fieldset": {
                      borderColor: "#C4C4C4",
                      borderRadius: "5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#C4C4C4",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C4C4C4",
                    },
                  },
                }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={1.25}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleReopenSubmit}
                disabled={read_only_user || selectedForReopen.size === 0}
                sx={{
                  backgroundColor: "#FF0400",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#FF0400",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#FFB4B4",
                  },
                  boxShadow: "none",
                  height: "46px",
                  border: "1px solid #C4C4C4",
                }}
              >
                Reopen
              </Button>
            </Grid>
            <Grid item xs={12} sm={1.25}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleApproveSubmit}
                disabled={read_only_user || selectedForApprove.size === 0}
                sx={{
                  backgroundColor: "#50AF47",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#50AF47",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#A8D5A5",
                  },
                  boxShadow: "none",
                  height: "46px",
                  border: "1px solid #C4C4C4",
                }}
              >
                Approve
              </Button>
            </Grid>
            <Grid item xs={12} sm={1.5}>
              <Button
                fullWidth
                variant="contained"
                disabled={loading || surveyData.length === 0}
                onClick={handleExportExcel}
                sx={{
                  backgroundColor: "#0F2B63",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#0F2B63",
                  },
                  fontFamily: "Montserrat",
                  fontWeight: "500",
                  fontSize: "10px",
                  height: "46px",
                  borderRadius: '10px',
                  '&.Mui-disabled': {
                    backgroundColor: "#102A62",
                    color: "#ffffff",
                    opacity: 0.6,
                  },
                }}
              >
                {loading && <CircularProgress size={20} />}
                EXPORT TO EXCEL
              </Button>
            </Grid>
          </Grid>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <>
              <SurveyTableSubGrower
                data={surveyData}
                isApprover={isApprover}
                cropYear={selectedCropYear}
                onAssignmentUpdate={handleAssignmentUpdate}
                selectedStatusPickList={selectedStatusPickList}
                isGlobalProfile={isGlobalProfile}
                selectedForReopen={selectedForReopen}
                selectedForApprove={selectedForApprove}
                isVisitCompliance={isVisitCompliance}
                selectedCountry={getXTenantIDHeader()}
                onViewSurvey={handleViewSurvey}
                onBulkActionChange={handleBulkActionChange}
                read_only_user={read_only_user}
              />
              {surveyData.length > 0 && (
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    bottom: "-70px",
                  }}
                >
                  <CustomPagination
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={(v) => setItemsPerPage(v)}
                    totalItems={totalItems}
                    paginate={paginate}
                    currentPage={currentPage}
                  />
                </div>
              )}
            </>
          )}
          <ReopenModal
            open={reopenModalOpen}
            onClose={() => setReopenModalOpen(false)}
            onConfirm={handleReopenConfirm}
            loading={loading}
          />
          <ApproveModal
            open={approveModalOpen}
            onClose={() => setApproveModalOpen(false)}
            onConfirm={handleApproveConfirm}
            loading={loading}
          />
        </Box>
      )}

      {currentView === "view" && (
        <ViewSurveySubGrower
          surveyData={selectedSurveyData}
          countries={countries}
          isVisitCompliance={isVisitCompliance}
          isGlobalProfile={isGlobalProfile}
          isApprover={isApprover}
          selectedCountry={getXTenantIDHeader()?.apiCountryCode}
          onBack={handleBack}
          onShowSignature={handleShowSignature}
          onRefreshData={() => fetchSurveyData(currentPage, itemsPerPage)}
          selectedCropStage={
            cropStages.find((stage) => stage.value === selectedCropStage)
              ?.label || "Crop Stage"
          }
          selectedCropStageCalendarId={selectedCropStageCalendarId}
          read_only_user={read_only_user}
        />
      )}

      {currentView === "signature" && (
        <SignaturePageSubGrower
          data={selectedSurveyData}
          onBack={() => setCurrentView("view")}
          isVisitCompliance={isVisitCompliance}
        />
      )}
      <DuplicateModal
        open={duplicateModal}
        onClose={() => setDuplicateModal(false)}
        message={duplicateMessage}
        loading={loading}
      />
    </Layout>
  );
};

export default SurveyReopenSubGrower;
